import { AuthorizeView } from "./_components";

export default function OauthAuthorizePage() {
  return <AuthorizeView />;
}
